export async function checkBrandReady(brandId: number, request: typeof fetch = fetch): Promise<string | null> {
  try {
    const response = await request(`/api/brands/${brandId}/readiness`, { credentials: 'include' });
    if (!response.ok) return 'We could not check your brand analysis. Please try again.';
    const state = await response.json();
    if (state.ready === true) return null;
    return state.code === 'BRAND_ANALYSIS_FAILED'
      ? 'Your brand analysis could not finish. Retry the analysis from your brand page before running this task.'
      : 'Please wait while your brand is being analyzed';
  } catch {
    return 'We could not check your brand analysis. Please try again.';
  }
}
